import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../api";
import AppLayout from "../components/AppLayout";
import { ErrorNote, Loading, formatBytes } from "../components/Feedback";
import { Badge, Btn, Card } from "../components/Shared";
import { useApi } from "../useApi";

// /releases/:uuid — one release by its uuid (GET /api/releases/{uuid}; task 2026-10-12-releases-
// omit-personal-columns-and-survive-a-project-delete, O18). It is where an ARCHIVED release lives,
// one whose project was deleted: its citation and files stay, for the members it
// names and for admins. A release of a live project links back to its project page.

export default function ReleasePage() {
  const { uuid } = useParams();
  const state = useApi(`/releases/${uuid}`);
  const [error, setError] = useState(null);
  const r = state.data;
  const get = async (path, filename) => {
    setError(null);
    try {
      await api.download(`/releases/${uuid}/${path}`, filename);
    } catch (err) {
      setError(err);
    }
  };
  const title = r ? r.title : "Release";
  return (
    <AppLayout title={title}>
      {state.loading && !r && <Loading label="Loading the release…" />}
      <ErrorNote error={state.error} />
      {r && (
        <Card>
          <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
            {r.archived ? <Badge color="gray">archived: project deleted</Badge>
              : <Link to={`/projects/${r.project_id}#release-${r.number}`}>Open the project</Link>}
            {(r.personal_data || []).length > 0 && <Badge color="red">personal data</Badge>}
            {(r.omitted_columns || []).length > 0 && <Badge color="gray">without personal data</Badge>}
          </div>
          <p style={{ fontSize: 13, color: "#4b5563" }}>
            Project {r.project_name} ({r.project_slug}) · design version {r.design_version ?? "?"}
            {r.status === "published" ? ` · ${r.parts.length} files, ${formatBytes(r.total_bytes)}` : ` · ${r.status}`}
          </p>
          {(r.omitted_columns || []).length > 0 && (
            <p style={{ fontSize: 13, color: "#4b5563" }}>
              Left out (marked as personal data): {r.omitted_columns.join(", ")}
            </p>
          )}
          {r.citation && (
            <>
              <div style={{ fontSize: 12, color: "#4b5563" }}>Cite as</div>
              <p data-testid="citation"
                 style={{ margin: "4px 0 12px", padding: "8px 10px", background: "#f3f4f6", borderRadius: 6, fontSize: 13 }}>
                {r.citation}
              </p>
            </>
          )}
          {r.status === "published" && (
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <Btn onClick={() => get("download", `${r.project_slug}-release-${r.number}.zip`)}>
                Download release {r.number}
              </Btn>
            </div>
          )}
          <ErrorNote error={error} />
        </Card>
      )}
    </AppLayout>
  );
}
